import { useEffect, useState } from 'react';


/**
 * Custom hook to get an animation start trigger.
 * This is necessary for components that are rendered conditionally and want to animate
 * when they mount on screen.
 * For example, if you conditionally render a sheet that slides from the side, rendering and
 * setting its visibility state in the same render cycle will cause the CSS animation to not run.
 * To support this use case, we enqueue a state update _right_ after the event loop tick via the
 * setTimeout without specifying a timer delay.
 */
export function useAnimationTrigger(): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timerId = setTimeout(() => setIsVisible(true));
    return () => clearTimeout(timerId);
  }, []);

  return [isVisible, setIsVisible];
}
